import { render, staticRenderFns } from "./TemplateManage.vue?vue&type=template&id=e9810c2a&scoped=true&"
import script from "./TemplateManage.vue?vue&type=script&lang=js&"
export * from "./TemplateManage.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManage.vue?vue&type=style&index=0&id=e9810c2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9810c2a",
  null
  
)

export default component.exports